import UserSessionService from '../services/user-session-service'
import { siteUrl } from '../shared/utils/siteUrl'
import stringToHash, { jsonToHash } from './crypto'

import pushEventDataLayerObj from './pushEventDataLayer'

/**
 *  PARSE FROME XCEL
 *  json={};
 *  s=` .... excel `
 *  json={};s.replaceAll("\t","|").replaceAll('|||','').split("\n").filter((str)=>str.trim().length>1).map((str)=>  str.split("|")  ).forEach((arr)=>{  json[arr[0]]={event:arr[1],category:arr[2],action:arr[3]}; })
 *
 */

interface ITagData {
  event?: string
  category?: string
  action?: string
}
var executed = false
const attribute_tag_names = ['data-tag']
const default_category = 'v-lab'
const TAGS: { [key: string]: ITagData } = {
  '0z': {
    event: 'Interactions_test',
  },

  '6A': {
    event: 'Interacciones_Menú_VLAB',
    category: 'Menu principal',
    action: 'click',
  },
  '7A': {
    event: 'Interacciones_Home_VLAB',
    category: 'Comenzar Actividad',
    action: 'click',
  },
  '8A': {
    event: 'Interacciones_T&C_VLAB',
    category: 'Actividad promocional',
    action: 'view',
  },
  '9A': {
    event: 'Interacciones_Login_VLAB',
    category: 'Inicio Sesion',
    action: 'click',
  },
  '10A': {
    event: 'Interacciones_Login_VLAB',
    category: 'Inicio Sesion',
    action: 'click',
  },
  '11A': {
    event: 'Interacciones_ActDatos_VLAB',
    category: 'Actualizar Datos',
    action: 'click',
  },
  '12A': {
    event: 'Interacciones_ActDatos_VLAB',
    category: 'Medio Validación',
    action: 'click',
  },
  '13A': {
    event: 'Interacciones_ActDatos_VLAB',
    category: 'Código Verificación',
    action: 'click',
  },
  '14A': {
    event: 'Interacciones_ActDatos_VLAB',
    category: 'Código Verificación',
    action: 'click',
  },
  '15A': {
    event: 'Interacciones_Redencion_VLAB',
    category: 'Redime y Acumula',
    action: 'click',
  },
  '16A': {
    event: 'Interacciones_Redencion_VLAB',
    category: 'Inscribir claves',
    action: 'click',
  },
  '17A': {
    event: 'Interacciones_TokenActivo_VLAB',
    category: 'Seguir jugando',
    action: 'click',
  },
  '18A': {
    event: 'Interacciones_Prejuego_VLAB',
    category: 'Bienvenida',
    action: 'click',
  },
  '19A': {
    event: 'Interacciones_Prejuego_VLAB',
    category: 'Instrucciones',
    action: 'click',
  },
  '20A': {
    event: 'Interacciones_Prejuego_VLAB',
    category: 'Logros',
    action: 'view',
  },
  '21A': {
    event: 'Interacciones_Juego_VLAB',
    category: '¿Deseas abandonar la partida?',
    action: 'click',
  },
  '22A': {
    event: 'Interacciones_Comentarios_VLAB',
    category: '¡Cuéntanos tu experiencia!',
    action: 'click',
  },
  '23A': {
    event: 'Interacciones_Juego_Nivel1_VLAB',
    category: 'Inicio Nivel 1',
    action: 'view',
  },
  '24A': {
    event: 'Interacciones_Juego_Nivel1_VLAB',
    category: 'Revisar de nuevo la fórmula',
    action: 'redimir',
  },
  '25A': {
    event: 'Interacciones_Juego_Nivel1_VLAB',
    category: 'Más tiempo',
    action: 'redimir',
  },
  '26A': {
    event: 'Interacciones_BonusTrack_VLAB',
    category: 'Bonus Track',
    action: 'click',
  },
  '27A': {
    event: 'Interacciones_Juego_Nivel1_VLAB',
    category: 'Fin Nivel 1',
    action: 'view',
  },
  '28A': {
    event: 'Interacciones_Juego_Nivel2_VLAB',
    category: 'Inicio Nivel 2',
    action: 'view',
  },
  '29A': {
    event: 'Interacciones_Juego_Nivel2_VLAB',
    category: 'Revisar de nuevo la fórmula',
    action: 'redimir',
  },
  '30A': {
    event: 'Interacciones_Juego_Nivel2_VLAB',
    category: 'Más tiempo',
    action: 'redimir',
  },
  '31A': {
    event: 'Interacciones_BonusTrack_VLAB',
    category: 'Bonus Track',
    action: 'click',
  },
  '32A': {
    event: 'Interacciones_Juego_Nivel2_VLAB',
    category: 'Fin Nivel 2',
    action: 'view',
  },
  '33A': {
    event: 'Interacciones_Juego_Nivel3_VLAB',
    category: 'Inicio Nivel 3',
    action: 'view',
  },
  '34A': {
    event: 'Interacciones_Juego_Nivel3_VLAB',
    category: 'Revisar de nuevo la fórmula',
    action: 'redimir',
  },
  '35A': {
    event: 'Interacciones_Juego_Nivel3_VLAB',
    category: 'Más tiempo',
    action: 'redimir',
  },
  '36A': {
    event: 'Interacciones_BonusTrack_VLAB',
    category: 'Bonus Track',
    action: 'click',
  },
  '37A': {
    event: 'Interacciones_Juego_VLAB',
    category: 'Obtener vida extra',
    action: 'click',
  },
  '38A': {
    event: 'Interacciones_Juego_VLAB',
    category: 'Redimir 5 puntos ',
    action: 'click',
  },
  '39A': {
    event: 'Interacciones_Fin_Juego_VLAB',
    category: '¡No superaste todos los niveles!',
    action: 'view',
  },
  '40A': {
    event: 'Interacciones_Fin_Juego_VLAB',
    category: '¡Completaste todos los niveles!',
    action: 'view',
  },
  '41A': {
    event: 'Interacciones_Fin_Juego_VLAB',
    category: 'Opciones fin de juego',
    action: 'click',
  },
  '42A': {
    event: 'Interacciones_Fin_Juego_VLAB',
    category: 'WOW, eres una Master',
    action: 'view',
  },
  '43A': {
    event: 'Interacciones_Fin_Juego_VLAB',
    category: 'Compartir',
    action: 'click',
  },
  '44A': {
    event: 'Interacciones_Fin_Juego_VLAB',
    category: 'Insignias',
    action: 'view',
  },
}

const isSSR = typeof window === 'undefined'

const default_location = siteUrl
const stored_user_data = {
  user_data: [],
  log_status: 'Not',
}
function getUserInfo() {
  return UserSessionService.getUserInfo()
}
async function getUserData() {
  const userInfo = getUserInfo()
  const logged = userInfo !== null
  const log_status = logged ? 'Yes' : 'Not'
  if (stored_user_data.log_status === log_status) {
    return stored_user_data
  }
  stored_user_data.user_data = logged
    ? [
        await jsonToHash({
          nombre: userInfo.name,
          apellido: userInfo.lastName,
          celular: userInfo.cellPhone,
          correo: userInfo.email,
          ciudad: userInfo.location?.cityName,
          departamento: userInfo.location?.countryStateName,
          pais: userInfo.countryName,
        }),
      ]
    : []
  stored_user_data.log_status = log_status
  return stored_user_data
}

async function pushData(obj) {
  const user = await getUserData()
  pushEventDataLayerObj({
    location: window ? window.location.href : default_location,

    category: default_category,
    ...obj,
    ...user,
  })
}
const observeDOM =
  !isSSR &&
  (function () {
    var MutationObserver =
      window.MutationObserver || window.WebKitMutationObserver

    return function (obj: HTMLElement, callback: () => void) {
      if (!obj || obj.nodeType !== 1) return

      if (MutationObserver) {
        // define a new observer
        var mutationObserver = new MutationObserver(callback)

        // have the observer observe for changes in children
        mutationObserver.observe(obj, { childList: true, subtree: true })
        return mutationObserver
      }

      // browser support fallback
      else if (window.addEventListener) {
        obj.addEventListener('DOMNodeInserted', callback, false)
        obj.addEventListener('DOMNodeRemoved', callback, false)
      }
    }
  })()
let debounceTimeId = 0

const bindsLinks: (() => void)[] = []
const onBindTagClick = (tagname: string, evt: any) => {
  if (!evt.target.attributes[tagname]) {
    return
  }
  if (evt.target.attributes[tagname].value.trim().length === 0) {
    return
  }
  const tag = evt.target.attributes[tagname].value
  const tagdata = TAGS[tag]
  pushData({
    tag,
    action: 'click',
    label: evt.target.innerText,
    ...tagdata,
  })
}
function clearBindLinks() {
  while (bindsLinks.length > 0) {
    const unbind = bindsLinks.shift()!
    unbind()
  }
}

function tagExist(tagName: string) {
  return TAGS.hasOwnProperty(tagName)
}

function bindEventTagOfElement(tagname: string, elem: HTMLElement) {
  if (
    elem.attributes.hasOwnProperty(tagname) &&
    elem.attributes[tagname] &&
    tagExist(elem.attributes[tagname].value)
  ) {
    const handler = evt => onBindTagClick(tagname, evt)
    elem.addEventListener('click', handler)
    bindsLinks.push(() => {
      elem.removeEventListener('click', handler)
    })
    return true
  } else {
    console.log(tagname, 'dont exist at', elem)
  }
  return false
}

function addAllBindClicks() {
  attribute_tag_names.forEach(tagname => {
    document.querySelectorAll(`[${tagname}]`).forEach(elem => {
      bindEventTagOfElement(tagname, elem)
    })
  })
}
function debounce(fnCallback: () => void, time = 500) {
  clearTimeout(debounceTimeId)
  debounceTimeId = setTimeout(fnCallback, time)
}
function onDomChange() {
  debounce(() => {
    clearBindLinks()
    addAllBindClicks()
  })
}
export const getBinds = () => bindsLinks
export const pageViewDataLayer = async () => {
  if (typeof document !== 'undefined') {
    const userInfo = getUserInfo()
    pushData({
      event: 'Page_View',
      action: 'view',
      title: document.title,
      page: window.location.pathname,
      userId: userInfo ? await stringToHash(userInfo.userId) : undefined,
    })
  }
}
export function initTagging() {
  if (executed) {
    return false
  }
  executed = true
  if (!isSSR) {
    observeDOM(document.body, onDomChange)
  }
}

interface ITriggerTageoOptions {
  action?: string
  label?: string
}
export function triggerTageo(
  tag: string,
  options: ITriggerTageoOptions | any = { action: 'click', label: '' }
) {
  const tagdata = TAGS[tag]
  pushData({
    tag,
    ...options,
    ...tagdata,
  })
}
